import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import CircularProgress from "@material-ui/core/CircularProgress";

export default class ForceProvisioningError extends Component {
    state = {
        error: false,
        showSnackBar: false,
        has_operation_running: false,
        opInProgress: false
    };

    componentDidMount() {
        const { resource_id } = this.props;
        const params = {
            filter: { export: true },
            pagination: { page: 1, perPage: 1000 },
            sort: { field: "customer_id", order: "asc" },
            id_inst: [resource_id],
            infoTransfer: true
        };
        myRestClient("GET_LIST", "installations", params).then(
            result => {
                this.setState({
                    has_operation_running: result.data[0].has_operation_running
                });
            },
            error => {
                return error;
            }
        );
    }

    handleOk = () => {
        const { resource_id } = this.props;
        const body = {
            id: resource_id,
            data: {
                action: "close_operation"
            },
            previousData: {
                password: null
            }
        };
        this.setState({ opInProgress: true });
        myRestClient("UPDATE", "installations", body).then(
            () => {
                this.setState({
                    showSnackBar: true,
                    error: false,
                    show_dialog: false,
                    opInProgress: false
                });
                window.location.reload();
            },
            () => {
                this.setState({
                    showSnackBar: true,
                    error: true,
                    show_dialog: false,
                    opInProgress: false
                });
            }
        );
    };

    handleCancel = () => {
        this.setState({
            show_dialog: false,
            opInProgress: false
        });
    };

    renderSnackBar() {
        return (
            <Snackbar
                open={this.state.showSnackBar}
                autoHideDuration={6000}
                message={this.renderSnackMessage()}
                onClose={_ =>
                    this.setState({
                        error: false,
                        showSnackBar: false
                    })
                }
            />
        );
    }

    renderSnackMessage() {
        return this.state.error === false ? (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.stopOperationSucceeded`}
                />
            </span>
        ) : (
            <span id="snack-message">
                <TranslatedText
                    resource_name={`resources.installations.actions.stopOperationFailed`}
                />
            </span>
        );
    }

    renderDialog() {
        return this.state.show_dialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.show_dialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText
                            resource_name={`resources.installations.actions.stop_operation`}
                        />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText
                        resource_name={`resources.installations.actions.stop_operation_warning`}
                    />
                </DialogContent>
                <DialogActions>
                    <div
                        align="center"
                        style={{
                            visibility: this.state.opInProgress
                                ? "visible"
                                : "hidden"
                        }}
                    >
                        {<CircularProgress />}
                    </div>
                    {!this.state.opInProgress && (
                        <div>
                            {" "}
                            <Button onClick={this.handleCancel} color="primary">
                                <TranslatedText
                                    resource_name={"ra.actions.cancel"}
                                />
                            </Button>
                            <Button
                                onClick={this.handleOk}
                                variant="contained"
                                color="secondary"
                            >
                                <TranslatedText
                                    resource_name={"ra.actions.ok"}
                                />
                            </Button>
                        </div>
                    )}
                </DialogActions>
            </Dialog>
        ) : null;
    }

    handleClickOpen = () => {
        const { booking } = this.props;
        if (booking) {
            this.setState({
                show_dialog: false
            });
        } else {
            this.setState({
                show_dialog: true
            });
        }
    };

    render() {
        return this.state.has_operation_running ? (
            <span>
                <Button
                    color="primary"
                    target="_blank"
                    // onClick={this.force}
                    onClick={this.handleClickOpen}
                >
                    <TranslatedText
                        resource_name={`resources.installations.actions.stop_operation`}
                    />
                </Button>
                {this.renderDialog()}
                {this.renderSnackBar()}
            </span>
        ) : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/StopOperationButton.js